import { render } from "./SignerRoomSA.vue?vue&type=template&id=568d567e&scoped=true"
import script from "./SignerRoomSA.vue?vue&type=script&lang=js"
export * from "./SignerRoomSA.vue?vue&type=script&lang=js"

import "./SignerRoomSA.vue?vue&type=style&index=0&id=568d567e&lang=css"
import "./SignerRoomSA.vue?vue&type=style&index=1&id=568d567e&scoped=true&lang=css"
import "./SignerRoomSA.vue?vue&type=style&index=2&id=568d567e&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568d567e"]])

export default __exports__